import axios from "axios";

const prepareData = (data) => {return {store_overalls_garment:data}}

// Plural Actions
export const GET_STORE_OVERALLS_GARMENTS = "get_store_overalls_garments";
export const getStoreOverallsGarments = () => {
	const url = `/store/overalls/garments.json`
	const request = axios.get(url);
	return {
		type: GET_STORE_OVERALLS_GARMENTS,
		payload: request
	};
};


// Singular Actions
export const CREATE_STORE_OVERALLS_GARMENT = "create_store_overalls_garment";
export const createStoreOverallsGarment = (data) => {
	const url = `/store/overalls/garments.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_STORE_OVERALLS_GARMENT,
		payload: request
	};
};

export const GET_STORE_OVERALLS_GARMENT = "get_store_overalls_garment";
export const getStoreOverallsGarment = (id) => {
	const url = `/store/overalls/garments/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_STORE_OVERALLS_GARMENT,
		payload: request
	};
};

export const UPDATE_STORE_OVERALLS_GARMENT = "update_store_overalls_garment";
export const updateStoreOverallsGarment = (id,data) => {
	const url = `/store/overalls/garments/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_STORE_OVERALLS_GARMENT,
		payload: request
	};
};

export const DESTROY_STORE_OVERALLS_GARMENT = "destroy_store_overalls_garment";
export const destroyStoreOverallsGarment = (id) => {
	const url = `/store/overalls/garments/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_STORE_OVERALLS_GARMENT,
		payload: request
	};
};
